export const TODO_API_END_POINT = {
  own_task_list: "/own-task/list",
  /* @description get all my-day task list -- get method
   */

  own_task_create: "/own-task/create",
  /* @description create my-day task  -- post method
   */

  own_task_getPending_id: "/own-task/getPending/",
  /* @description get all my-day pending task list -- get method -- pass user id as parameter
   */

  own_task_getCompleted_id: "/own-task/getCompleted/",
  /* @description get all my-day completed task list -- get method -- pass user id as param
   */

  own_task_update_id: "/own-task/update/",
  /* @description update my-day task -- put method -- pass task id as param
   */

  own_task_getby_id: "/own-task/getby/",
  /* @description get all my-day task list of user -- get method -- pass user id as param
   */
  own_task_export_id: "/own-task/export/",
  /* @description post method -- pass user id as param
   */

  todo_list_list: "/todo-list/list",
  /* @description get all todo-list list-- get method
   */

  todo_list_create: "/todo-list/create",
  /* @description create todo-list -- post method
   */

  todo_list_update_id: "/todo-list/update/",
  /* @description update todo-list -- put method -- pass todo-list id as param
   */

  todo_list_getById_id: "/todo-list/getById/",
  /* @description get method -- pass user id as param
   */

  todo_list_getList_id: "/todo-list/getList/",
  /* @description get method -- pass todo-list id as param
   */

  todo_list_get_id: "/todo-list/get/",
  /* @description get method -- pass todo-list id as param -- get list shares
   */

  todo_list_shared: "/todo-list/shared",
  /* @description post method -- share list
   */

  todo_task_create: "/todo-task/create",
  /* @description post method -- create todo-task
   */

  todo_task_update_id: "/todo-task/update/",
  /* @description put method -- update todo-task pass todo-task id as param
   */

  todo_task_list: "/todo-task/list",
  /* @description get method -- get all todo-task
   */

  todo_task_getByListId_id: "/todo-task/getByListId/",
  /* @description get method -- pass todo-list id as param
   */

  todo_task_getPending_id: "/todo-task/getPending/",
  /* @description get method -- pass user id as param
   */

  todo_task_getCompleted_id: "/todo-task/getCompleted/",
  /* @description get method -- get all todo-task
   */

  todo_task_getTask_id: "/todo-task/getTask/",
  /* @description get method -- pass todo-task id as param
   */

  todo_task_assignedTo_id: "/todo-task/assignedTo/",
  /* @description get method -- pass user id as param
   */
  user_getByRole: "/user/getByRole/",
  /* @description get method -- pass role as param 
get user list
*/

  user_getListShared_id: "/user/getListShared/",
  /* @description get method -- pass user id as param
get list shared with user
*/
  delete_own_task: "/own-task/delete/",
  /* @description delete method -- passed user id and delete form list*/

  delete_todo_task: "/todo-task/delete/",
  /* @description delete method -- passed user id and delete form assign to other list */

  delete_todo_list: "/todo-list/delete/",
  /* @description delete method -- passed user id and delete form assign list*/
};
